import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Para qué edad es este material?',
  answer: 'Está diseñado para adolescentes de 12 a 18 años. El lenguaje, los ejercicios y las actividades están adaptados a su realidad: redes sociales, presión académica, relaciones y búsqueda de identidad.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Inmediatamente después de tu compra recibís un email con el enlace de descarga. Todo el material es 100% digital en formato PDF, listo para usar desde cualquier dispositivo o para imprimir.'
}, {
  question: '¿Lo puede usar el adolescente solo o necesita un adulto?',
  answer: 'Ambas opciones funcionan. Los tomos están diseñados para que el adolescente pueda trabajarlos de forma autónoma, pero también incluyen guías para que padres, docentes o terapeutas acompañen el proceso y potencien los resultados.'
}, {
  question: '¿Qué lo diferencia de otros materiales sobre emociones?',
  answer: 'Este es un sistema completo y estructurado con +500 páginas de contenido profesional, no tips sueltos ni artículos genéricos. Cada tomo sigue una secuencia pedagógica pensada para generar cambios reales y medibles. Incluye ejercicios prácticos, guías paso a paso y herramientas de aplicación inmediata.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Tenés 7 días completos para probarlo. Si no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas, sin formularios, sin drama. Nuestra tasa de devoluciones es menor al 1%.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-16 px-4 bg-gray-50" data-id="element-61">
      <div className="max-w-3xl mx-auto" data-id="element-62">
        <div className="text-center mb-12" data-id="element-63">
          <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-64">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
          <div className="w-24 h-2 bg-blue-600 mx-auto rounded-full" data-id="element-65"></div>
        </div>

        <div className="space-y-3" data-id="element-66">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-67">
              <button onClick={() => toggle(index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer" data-id="element-68">
                <span className="text-lg md:text-xl font-bold text-gray-900 pr-4" data-id="element-69">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 md:w-6 md:h-6 text-gray-500 flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-70" />
              </button>
              {openIndex === index && <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-71">
                  <p className="text-base md:text-lg text-gray-600 font-medium leading-relaxed" data-id="element-72">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}